import { render, staticRenderFns } from "./RenderSubSectionPopulation.vue?vue&type=template&id=7ac1161a"
import script from "./RenderSubSectionPopulation.vue?vue&type=script&lang=js"
export * from "./RenderSubSectionPopulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports